import { useEffect, useState } from 'react'
import { API_BASE_URL } from '../../lib/config'
import { FALLBACK_SKILLS, type SkillCard } from '../lib/skills'

const mapSkill = (s: SkillCard): SkillCard => ({
  id: s.id,
  title: s.title,
  description: s.description,
  icon: s.icon,
  starter_message: s.starter_message,
  requires_business_type: s.requires_business_type,
})

/** Loads skill catalog from API; falls back to static list. */
export const useSkills = () => {
  const [skills, setSkills] = useState<SkillCard[]>(FALLBACK_SKILLS)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const ac = new AbortController()
    const load = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}chat/skills`, {
          credentials: 'include',
          signal: ac.signal,
        })
        if (!res.ok) return
        const data = await res.json()
        const list = Array.isArray(data?.skills) ? data.skills : []
        if (list.length > 0) setSkills(list.map(mapSkill))
      } catch (err) {
        if ((err as { name?: string })?.name === 'AbortError') return
      } finally {
        if (!ac.signal.aborted) setLoading(false)
      }
    }
    void load()
    return () => ac.abort()
  }, [])

  return { skills, loading }
}
